import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=a22da75a&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderDetail.vue?vue&type=style&index=0&id=a22da75a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a22da75a",
  null
  ,true
)

export default component.exports